


































import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { detect, BrowserInfo } from 'detect-browser'
import {
        AtomSpinner,
        FlowerSpinner,
        PixelSpinner,
        HollowDotsSpinner,
        IntersectingCirclesSpinner,
        RadarSpinner,
        ScalingSquaresSpinner,
        HalfCircleSpinner,
        TrinityRingsSpinner,
        FulfillingSquareSpinner,
        CirclesToRhombusesSpinner,
        SemipolarSpinner,
        SelfBuildingSquareSpinner,
        SwappingSquaresSpinner,
        FulfillingBouncingCircleSpinner,
        FingerprintSpinner,
        SpringSpinner,
        LoopingRhombusesSpinner,
        BreedingRhombusSpinner,
} from 'epic-spinners'

import FlagSpinner from '@/components/spinners/FlagSpinner.vue'
import KeyValuePair from '@/modules/core/support/KeyValuePair'
import { State } from 'vuex-class'

@Component({
    components: {
        AtomSpinner,
        FlowerSpinner,
        PixelSpinner,
        HollowDotsSpinner,
        IntersectingCirclesSpinner,
        RadarSpinner,
        ScalingSquaresSpinner,
        HalfCircleSpinner,
        TrinityRingsSpinner,
        FulfillingSquareSpinner,
        CirclesToRhombusesSpinner,
        SemipolarSpinner,
        SelfBuildingSquareSpinner,
        SwappingSquaresSpinner,
        FulfillingBouncingCircleSpinner,
        FingerprintSpinner,
        SpringSpinner,
        LoopingRhombusesSpinner,
        BreedingRhombusSpinner,
        FlagSpinner,
    },
})
export default class LoadingScreenComponent extends Vue {
    @Prop({type: Boolean, default: false})
    public fullscreen: boolean

    @Prop({type: Boolean, default: true})
    public brand: boolean

    @State(state => state.loadingScreen.determinate)
    public determinate: boolean

    @State(state => state.loadingScreen.progress)
    public progress: number

    @State(state => state.loadingScreen.progressMessage)
    public progressMessage: string

    @State
    public darkMode: boolean

    public currentSpinner: KeyValuePair | null
    public readonly browser = detect()

    public spinners = [
        // { component: 'v-progress-circular', props: { indeterminate: true }},
        { component: 'AtomSpinner'},
        { component: 'FlowerSpinner', skipInChrome: true},
        { component: 'PixelSpinner', skipInChrome: true},
        { component: 'HollowDotsSpinner'},
        { component: 'IntersectingCirclesSpinner'},
        { component: 'RadarSpinner' },
        { component: 'ScalingSquaresSpinner'},
        { component: 'HalfCircleSpinner'},
        { component: 'TrinityRingsSpinner'},
        { component: 'FulfillingSquareSpinner'},
        { component: 'CirclesToRhombusesSpinner'},
        { component: 'SemipolarSpinner'},
        { component: 'SelfBuildingSquareSpinner'},
        { component: 'SwappingSquaresSpinner'},
        { component: 'FulfillingBouncingCircleSpinner'},
        { component: 'FingerprintSpinner'},
        { component: 'SpringSpinner', skipInChrome: true},
        { component: 'LoopingRhombusesSpinner'},
        { component: 'BreedingRhombusSpinner'},
        { component: 'FlagSpinner'},
    ]

    public randomSpinner () {
        const browserName = (this.browser as BrowserInfo).name
        let spinner = this.spinners[Math.floor(Math.random() * this.spinners.length)];
        do {
            spinner = this.spinners[Math.floor(Math.random() * this.spinners.length)];
        } while (browserName === 'chrome' && spinner.skipInChrome)

        this.currentSpinner = spinner
    }

    public created () {
        this.randomSpinner()
    }
}
